const SentryInit = () => (
  <button onClick={() => methodDoesNotExist()}>Break the world</button>
);

export default SentryInit;
